import { render, staticRenderFns } from "./Call-Select.vue?vue&type=template&id=a96c512a&"
import script from "./Call-Select.vue?vue&type=script&lang=js&"
export * from "./Call-Select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports